import { IdBuilding } from "../../../../../constants/IdBuilding";
import { createPathSelectBuildingInBuildMenu } from "../../../path/createPathSelectBuildingInBuildMenu";
export var pathSelectDecoCouponBuildingInBuildMenu = function (action, state$, deps) { return createPathSelectBuildingInBuildMenu(function () { return IdBuilding.GnomePinwheels; })(action, state$, deps); };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/spend-resource/paths/pathSelectDecoCouponBuildingInBuildMenu.ts
// module id = 2384
// module chunks = 3